export default "<app-tutor-toolbar></app-tutor-toolbar>\n<main>\n    <app-class-tile [myClass]=\"7\"></app-class-tile>\n</main>\n"